export enum RiderTransportationTypeEnum {
    None = 0,
    Car = 1,
    Moto = 2
}
